/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { DealerAddress } from './DealerAddress'
import {
  DealerAddressFromJSON,
  DealerAddressFromJSONTyped,
  DealerAddressToJSON,
} from './DealerAddress'

/**
 *
 * @export
 * @interface Dealer
 */
export interface Dealer {
  /**
   *
   * @type {string}
   * @memberof Dealer
   */
  scaniaId?: string | null
  /**
   *
   * @type {string}
   * @memberof Dealer
   */
  organizationName?: string | null
  /**
   *
   * @type {DealerAddress}
   * @memberof Dealer
   */
  visitingAddress?: DealerAddress | null
  /**
   *
   * @type {string}
   * @memberof Dealer
   */
  customerReceptionPhoneNumber?: string | null
}

/**
 * Check if a given object implements the Dealer interface.
 */
export function instanceOfDealer(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function DealerFromJSON(json: any): Dealer {
  return DealerFromJSONTyped(json, false)
}

export function DealerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Dealer {
  if (json === undefined || json === null) {
    return json
  }
  return {
    scaniaId: !exists(json, 'ScaniaId') ? undefined : json['ScaniaId'],
    organizationName: !exists(json, 'OrganizationName')
      ? undefined
      : json['OrganizationName'],
    visitingAddress: !exists(json, 'VisitingAddress')
      ? undefined
      : DealerAddressFromJSON(json['VisitingAddress']),
    customerReceptionPhoneNumber: !exists(json, 'CustomerReceptionPhoneNumber')
      ? undefined
      : json['CustomerReceptionPhoneNumber'],
  }
}

export function DealerToJSON(value?: Dealer | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    ScaniaId: value.scaniaId,
    OrganizationName: value.organizationName,
    VisitingAddress: DealerAddressToJSON(value.visitingAddress),
    CustomerReceptionPhoneNumber: value.customerReceptionPhoneNumber,
  }
}
